import React, { useState, useEffect, useContext } from "react";
import Header from "./Header";
import MasterMenuFilters from "./MasterMenuFilters";
import MasterMenuTables from "./MasterMenuTables";
import SubHeader from "./SubHeader";
import { openDB } from "idb";
import DeliveryTakeawayCard from "./DeliveryTakeawayCard";
import Context from "../context/context";
import CustomDropDown from "./CustomDropDown"

import NewMenu from "./NewMenu";
let timeoutId;
const MasterMenu = ({
  handleSeatOpen,
  handleSectionOpen,
  handleBulkUploadOpen,
  read,
  isNewSeatAdded,
  newSectionCreated,
  setNewSectionCreated,
  sectionDragged,
  selectedValue, setSelectedValue, isSeatModified, setIsSeatModified
}) => {

  const context = useContext(Context);
  const { generateMenues, setUnAuthPopup, updateUnSync } = context;
  const [tables, setTables] = useState([]);

  const [selectedMenu, setSelectedMenu] = useState(false);
  const [seatsAttachedToMenu, setSeatsAttachedToMenu] = useState(false);
  const [menus, setMenus] = useState([]);
  let restrictions = JSON.parse(sessionStorage.getItem("+restrictions")) || []

  const [brands, setBrands] = useState([]);
  const [newMenuPopup, setNewMenuPopup] = useState(false);
  const [brandSelection, setBrandSelection] = useState({ selected: '', visible: false, options: [] })

  const noWarning = () => {
    setUnAuthPopup(true);
    setTimeout(() => setUnAuthPopup(false), 3000);
  }

  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const indSections = await db.transaction("outlet", "readonly").objectStore("outlet");
      const outlet = (await indSections.getAll())[0];
      setTables(outlet.section_details?.sort((a, b) => {
        if (+a.section_sort_order < +b.section_sort_order) {
          return -1;
        }
        if (+a.section_sort_order > +b.section_sort_order) {
          return 1;
        }
        return 0;
      }));
      setBrands(outlet.brand_uuid)

      const indSeats = await db.transaction("seats", "readonly").objectStore("seats");
      const allSeats = await indSeats.getAll();
      const selectedMenuSeats = allSeats.filter(seat => seat.menu_details?.find((menu) => menu.menu_uuid === selectedMenu?.menu_uuid));
      setSeatsAttachedToMenu(selectedMenuSeats);

      if (brandSelection?.selected) return;
      let tx = db.transaction("brand", "readonly").objectStore("brand");
      const brandsData = (await tx.getAll())?.filter(i => outlet?.brand_uuid?.includes(i.brand_uuid));
      const doc = {};
      if (brandsData?.length > 1) doc.options = brandsData;
      doc.selected = brandsData[0]?.brand_uuid;

      setBrandSelection(curr => ({ ...curr, ...doc }))
    };
    getDataFromIndexdDb();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newSectionCreated, isSeatModified, sectionDragged, selectedMenu, menus]);

  useEffect(() => {
    if (menus.legth) {
      const generated_collection = sessionStorage.getItem("generated-collection")
      sessionStorage.setItem("generated-collection", { ...generated_collection, menues: menus })
    }
  }, [menus])

  function menuGenerationTimeout() {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      generateMenues()
    }, 5000);
  }

  const updateMenusData = async (updatedMenus) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("menu", "readwrite").objectStore("menu");

    await updatedMenus.map(async (data) => {
      await tx.put(Object.keys(data)
        .filter((key) => key !== "RECON_TIME")
        .reduce((obj, key) => {
          obj[key] = data[key];
          return obj;
        }, {}));
      await updateUnsycedData(data);
      await handleReconciliation(data);
    })

    console.log("generating menues")
    menuGenerationTimeout()
  }

  const handleReconciliation = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = await db
      .transaction("reconciliation", "readwrite")
      .objectStore("reconciliation");
    const allReconRecords = await tx.getAll();

    const sectionsJsonExists = allReconRecords.find(
      (curr) => curr.IDENTIFIER === "menu"
    );
    if (sectionsJsonExists) {
      const sections = sectionsJsonExists?.details?.filter(
        (section) => section.menu_uuid !== data.menu_uuid
      );
      const editData = {
        ...sectionsJsonExists,
        details: [
          ...sections,
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.put(editData);
    } else {
      const newdata = {
        IDENTIFIER: "menu",
        details: [
          {
            menu_uuid: data.menu_uuid,
            RECON_TIME: data.RECON_TIME,
          },
        ],
      };
      await tx.add(newdata);
    }
  };

  const updateUnsycedData = async (data) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("unsynced_files", "readwrite").objectStore("unsynced_files");

    const ndata = {
      ...data,
      RECON_TIME: data.RECON_TIME,
      IDENTIFIER: "menu-edit:" + data.menu_uuid,
    };
    await tx.put(ndata)
    updateUnSync()

  }

  const onBrandSelection = async brand_uuid => {
    setBrandSelection(curr => ({ ...curr, visible: false, selected: brand_uuid }))
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const tx = db.transaction("menu", "readonly").objectStore("menu");
    let IDBMenus = await tx.getAll();
    IDBMenus = await IDBMenus?.filter(i => i.brand_uuid === brand_uuid)
    setSelectedMenu(IDBMenus[0])
    setMenus(IDBMenus);
  }

  useEffect(() => {
    if (brandSelection?.selected && menus?.find(i => i.brand_uuid !== brandSelection?.selected)) {
      setMenus(menus?.filter(i => i.brand_uuid === brandSelection?.selected))
    }
  }, [brandSelection?.selected, menus])

  // console.log("menu", menus)
  return (<>
    <div className="master-menu" >
      <Header />
      <SubHeader
        title="Menus"
        headerActions={
          <>
            {brandSelection?.options?.length > 1 ?
              <CustomDropDown
                label={'Select Brand'}
                state={brandSelection}
                setState={setBrandSelection}
                onSelect={onBrandSelection}
                styles={{
                  container: { position: 'unset', margin: '7px 0' }
                }}
                valueTargetKey={'brand_uuid'}
                labelTargetKey={'brand_name'}
              /> : ''}
            <button onClick={handleBulkUploadOpen}> + Bulk Upload </button>
            {brands.filter(a => a).length ? <button onClick={() => {
              setNewMenuPopup(true);
            }}> + Add Menu </button> : ""}
          </>
        }
      />
      <MasterMenuFilters setSelectedMenu={setSelectedMenu} selectedMenu={selectedMenu} menus={menus} setMenus={setMenus} newMenuPopup={newMenuPopup} handleSectionOpen />
      <SubHeader
        title="Seats"
        headerActions={
          <>
            {/* <button onClick={() => updateSeatDb(true)}>Apply Changes</button> */}
            <button onClick={() => +restrictions[0]?.other_menu_and_seat_new_edit_seat_section === 0 ? noWarning() : handleSectionOpen()}>+ Section</button>
            <button onClick={() => +restrictions[0]?.other_menu_and_seat_new_edit_seat_section === 0 ? noWarning() : handleSeatOpen()}>+ Seat</button>
          </>
        }
      />
      <div className="mastermenttable">
        <DeliveryTakeawayCard updateMenusData={updateMenusData} selectedMenu={selectedMenu} menus={menus} setMenus={setMenus} />
        {tables.map((item, i) => {
          return (
            <MasterMenuTables
              isNewSeatAdded={isNewSeatAdded}
              newSectionCreated={newSectionCreated}
              setNewSectionCreated={setNewSectionCreated}
              read={read}
              key={i}
              item={item}
              isSeatModified={isSeatModified}
              setIsSeatModified={setIsSeatModified}
              sectionDragged={sectionDragged}
              selectedMenu={selectedMenu}
              seatsAttachedToMenu={seatsAttachedToMenu}
              setSeatsAttachedToMenu={setSeatsAttachedToMenu}
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              brand_uuid={brandSelection?.selected}
            />
          );
        })}
      </div>
    </div>
    {newMenuPopup ? <NewMenu menus={menus} brands={brands} close={() => setNewMenuPopup(false)} /> : ""}
  </>
  );
};
export default MasterMenu;

